import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";
import { UserService } from ".././shared/services/user.service";
import * as _ from "lodash";
import {
  AvailabilityPostModel,
  UserHoursOfOperations,
} from "../shared/models/availabilitiyPostModel";
import moment from "moment";
import {
  AvailabilityGridModel,
  UserRotation,
} from "../shared/models/availabilitiyGridModel";
import { HomeLocation } from "../shared/models/homeLocationsModel";
import { ToastService } from "src/app/shared/services/toast.service";
import { LocationIdModel } from "../shared/models/locationIdModel";
import { UserRotationByDateRange } from "../shared/models/userRotationByDateRange";
import { AvailabilityTemplate } from "../shared/models/availabilityTemplate";
import { IListItemModel } from "../shared/models/listItemModel";
import { AvailabilityTemplateDay } from "../shared/models/availabilityTemplateDay";
import { AvailabilityTimeRange } from "../shared/models/availabilityTimeRange";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { MeetingPreference } from "../shared/models/meetingPreference.enum";
import { UserAvailabilityRotationModel } from "../shared/models/UserAvailabilityRotationCalendarModel";
import { TranslationLoaderFacade } from "../../localization/translation-loader.facade";
import { TranslateService } from "@ngx-translate/core";
import { UserEditDetails } from "../shared/models/userEditDetailsModel";
import { ILocationModel } from "../../location/shared/models/LocationModel";

interface IAllMPs {
  [index: number]: Array<IListItemModel>;
}
@Component({
  selector: "app-user-availability",
  templateUrl: "./user-availability.component.html",
  styleUrls: ["./user-availability.component.scss"],
})
export class UserAvailabilityComponent implements OnInit {
  @Output() dirtyEmitter = new EventEmitter<boolean>(false);
  @Output() closeEmitter = new EventEmitter();

  public allGridData: AvailabilityGridModel[] = [];
  public moveList: IListItemModel[] = [];
  public availabilityGridData:
    | AvailabilityTemplate
    | AvailabilityTemplate[]
    | UserHoursOfOperations[]
    | UserRotation[]
    | undefined;
  public availabilityGridDataNew: AvailabilityTemplate[] = [];
  public availabilityGridDataDisplay: AvailabilityTemplateDay[] = [];
  public userAvailabilityTemplate = new AvailabilityPostModel();
  public userAvailabilityGridTemplate: AvailabilityGridModel[] = [];
  public originalUserAvailabilityGridTemplate: AvailabilityGridModel[] = [];
  public originalUserAvailabilityGridTemplateNew: AvailabilityTemplate[] = [];
  public rotate: IListItemModel = { id: 1, displayValue: "Rotation 1" };
  public rotationList: Array<IListItemModel> = [];
  public selectedRotation: IListItemModel | null = null;
  public rotationSelectedDates: Date[] = [];
  public rotationStartDate: Date = new Date();
  public rotationEndDate: Date = new Date();
  public date: Date = new Date();
  public show: boolean = false;
  public show1: boolean = false;
  public show2: boolean = false;
  public eTime: Date = new Date();
  public sTime: Date = new Date();
  public anchor: any;
  public anchor1: any;
  public anchor2: any;
  public defaultItem: location | null = null;
  public homeLocationType: number | null = null;
  public editingUser: UserEditDetails | null = null;
  public editingUserId: number = 0;
  public isSaveDisabled: boolean = true;
  public userWorkLocationList: HomeLocation[] = [];
  public appointmentsEnabled: boolean = false;
  public invalidMeetingPreference: boolean = false;
  public meetingPreferenceList: Array<IListItemModel> = [];
  public showUnsaveChangesInAppointmentPopup: boolean = false;
  public isAvailabilityTimeRangesValid: boolean = true;
  public disableButonsToolTip: string = "";
  private newIndex: number | null = null;
  public showRemove: boolean = false;
  public allMPs: IAllMPs = {};
  public useHomeLocationText: string = "";
  public useFLoatLoactionText: string = "";

  // Date Picker
  public steps: { minute: number } = { minute: 15 };
  public dateFormat: string = "HH:mm";

  public dropdownSettings: IDropdownSettings = {
    idField: "id",
    textField: "displayValue",
    itemsShowLimit: 5,
    enableCheckAll: false,
  };

  constructor(
    private userService: UserService,
    public toastService: ToastService,
    private cd: ChangeDetectorRef,
    private translationLoaderFacade: TranslationLoaderFacade,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.translateService
      .get([
        "_User_Use_Float_Locations_Ts_Text_",
        "_User_Home_Float_Locations_Ts_Text_",
      ])
      .subscribe((res) => {
        this.useHomeLocationText = res["_User_Home_Float_Locations_Ts_Text_"];
        this.useFLoatLoactionText = res["_User_Use_Float_Locations_Ts_Text_"];
      });

    this.newIndex = -1;
    this.showUnsaveChangesInAppointmentPopup = false;
    this.loadAvailabilityTemplateData();
  }

  public adoptAvailablityDataSet() {
    var currentDate = new Date();
    var userAvailablituTemplateMap = new Map();
    var userAvailablituMapDay = new Map();

    const weekNumbers = new Set<number>();
    this.editingUser?.userHoursOfOperations.forEach((element) => {
      weekNumbers.add(element.weekNumber);
    });

    weekNumbers.forEach((weekNum) => {
      userAvailablituMapDay = new Map();
      for (let dayNum = 0; dayNum <= 6; dayNum++) {
        const defaultStartTime = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          9,
          0,
          0,
        );
        const defaultEndTime = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          17,
          0,
          0,
        );

        let day = new AvailabilityTemplateDay();
        day.dayOfWeek = dayNum;
        day.weekNumber = weekNum;
        day.isAvailable = false;
        day.availabilityTimeRange = [];

        let timerange = new AvailabilityTimeRange();
        timerange.userHoursOfOperationId = this.newIndex!--;
        timerange.startTime = defaultStartTime;
        timerange.endTime = defaultEndTime;
        timerange.userWorkLocation = null;
        timerange.eligibleForVirtualAppointments = false;
        timerange.eligibleForInPersonAppointments = false;
        timerange.eligibleForPhoneAppointments = false;
        timerange.selectedMeetingPreference = [] as Array<IListItemModel>;

        day.availabilityTimeRange.push(timerange);
        userAvailablituMapDay.set(weekNum + "|" + dayNum, day);
      }
      userAvailablituTemplateMap.set(weekNum, userAvailablituMapDay);
    });

    this.editingUser?.userHoursOfOperations.forEach((element) => {
      userAvailablituMapDay = userAvailablituTemplateMap.get(
        element.weekNumber,
      );

      if (
        userAvailablituMapDay.has(element.weekNumber + "|" + element.dayNumber)
      ) {
        const existingDay = userAvailablituMapDay.get(
          element.weekNumber + "|" + element.dayNumber,
        );

        if (
          existingDay.availabilityTimeRange.length === 1 &&
          existingDay.availabilityTimeRange[0].userHoursOfOperationId! < 0
        ) {
          existingDay.availabilityTimeRange = [];
          existingDay.isAvailable = element.isAvailable;
        }

        let timerange = new AvailabilityTimeRange();
        timerange.userHoursOfOperationId = element.userHoursOfOperationId;
        var starttime = element.startTime.split(":", 3);
        timerange.startTime = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          parseInt(starttime[0]),
          parseInt(starttime[1]),
          parseInt(starttime[2]),
        );
        var endtime = element.endTime.split(":", 3);
        timerange.endTime = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          parseInt(endtime[0]),
          parseInt(endtime[1]),
          parseInt(endtime[2]),
        );
        timerange.userWorkLocation = element.workLocationId;
        timerange.eligibleForVirtualAppointments =
          element.eligibleForVirtualAppointments;
        timerange.eligibleForInPersonAppointments =
          element.eligibleForInPersonAppointments;
        timerange.eligibleForPhoneAppointments =
          element.eligibleForPhoneAppointments;
        timerange.selectedMeetingPreference = [] as Array<IListItemModel>;
        if (element.eligibleForInPersonAppointments) {
          timerange.selectedMeetingPreference.push({
            id: MeetingPreference.InPerson,
            displayValue: this.translateService.instant(
              "_User_In_Person_Ts_Text_",
            ),
            isDisabled: false,
          });
        }
        if (element.eligibleForPhoneAppointments) {
          timerange.selectedMeetingPreference.push({
            id: MeetingPreference.Phone,
            displayValue: this.translateService.instant("_General_Phone_Text_"),
            isDisabled: false,
          });
        }
        if (element.eligibleForVirtualAppointments) {
          timerange.selectedMeetingPreference.push({
            id: MeetingPreference.Virtual,
            displayValue: this.translateService.instant(
              "_General_Virtual_Text_",
            ),
            isDisabled: false,
          });
        }
        this.invalidMeetingPreference =
          this.appointmentsEnabled &&
          element.isAvailable &&
          timerange.selectedMeetingPreference.length == 0;
        existingDay.availabilityTimeRange.push(timerange);
      }
    });

    var templateArray: AvailabilityTemplate[] = [];
    for (let key of userAvailablituTemplateMap.keys()) {
      var template = new AvailabilityTemplate();
      template.availabilityTempateDay = [];
      this.translateService
        .get(["_General_Rotation_Text_"])
        .subscribe((translations) => {
          this.rotationList.push({
            id: key,
            displayValue: translations["_General_Rotation_Text_"] + " " + key,
          });
        });
      for (let daykey of userAvailablituTemplateMap.get(key).keys()) {
        var availabilityday = userAvailablituTemplateMap.get(key).get(daykey);
        template.availabilityTempateDay.push(availabilityday);
      }
      templateArray.push(template);
    }
    this.availabilityGridDataNew = templateArray;

    this.setMeetingPrefSelectorState(
      templateArray,
      this.meetingPreferenceList,
      this.allMPs,
    );

    this.rotate = this.rotationList[0];
    this.userService.avialabilityTempGridDataSet = this.availabilityGridDataNew;
    // display the first rotation in the grid table
    this.availabilityGridDataDisplay =
      this.availabilityGridDataNew[this.rotate.id - 1].availabilityTempateDay;
  }

  public isSaveButtonDisabled() {
    return (
      this.invalidMeetingPreference ||
      this.isSaveDisabled ||
      !this.isAvailabilityTimeRangesValid
    );
  }

  public changeMeetingPreferencesDropDownValues(selectedPreferences: []) {
    const clonedPrefs = _.cloneDeep(selectedPreferences);
    this.availabilityGridDataNew.forEach((element) => {
      element.availabilityTempateDay.forEach((day) => {
        day.availabilityTimeRange.forEach((timerange) => {
          timerange.selectedMeetingPreference = _.cloneDeep(clonedPrefs);
        });
      });
    });
    this.isSaveDisabled = false;
  }

  public loadAvailabilityTemplateData() {
    Date.prototype.toJSON = function () {
      return moment(this).format();
    };
    this.editingUser = this.userService.getEditingUser();
    if (this.editingUser) {
      this.editingUserId = this.editingUser.userDetails.userId;
      this.sortUserOperationalHours(this.editingUser);
      this.assignMeetingPreferenceOptions();
      this.getHomeLocationList();
      this.appointmentsEnabled =
        this.editingUser.userDetails.appointmentsEnabled;
      this.availabilityGridData = this.editingUser
        .userHoursOfOperations as UserHoursOfOperations[];
    }
    this.timeRangeValidate();
  }

  /**
   * Assign Meeting Preference Options to the dropdown when loading the user details according to their meeting preference options in Appointment Settings
   */
  assignMeetingPreferenceOptions() {
    this.meetingPreferenceList = [];
    if (this.editingUser?.userDetails.eligibleForInPersonAppointments) {
      this.meetingPreferenceList.push({
        id: MeetingPreference.InPerson,
        displayValue: this.translateService.instant("_User_In_Person_Ts_Text_"),
        isDisabled: false,
      });
    }
    if (this.editingUser?.userDetails.eligibleForPhoneAppointments) {
      this.meetingPreferenceList.push({
        id: MeetingPreference.Phone,
        displayValue: this.translateService.instant("_General_Phone_Text_"),
        isDisabled: false,
      });
    }
    if (this.editingUser?.userDetails.eligibleForVirtualAppointments) {
      this.meetingPreferenceList.push({
        id: MeetingPreference.Virtual,
        displayValue: this.translateService.instant("_General_Virtual_Text_"),
        isDisabled: false,
      });
    }
  }
  /*
   * Get available home location list
   */
  getHomeLocationList() {
    this.userService
      .getLHomeLocations()
      .subscribe((response: HomeLocation[]) => {
        this.doFloatLocationOperation(response);
        this.getUserAvailablityTemplateData();

        //debugger
        this.allGridData = this.userAvailabilityGridTemplate;
        this.originalUserAvailabilityGridTemplate = JSON.parse(
          JSON.stringify(this.userAvailabilityGridTemplate),
        );
        this.originalUserAvailabilityGridTemplate =
          this.convertOriginalGridDataSet(
            this.originalUserAvailabilityGridTemplate,
          );

        this.adoptAvailablityDataSet();
        this.originalUserAvailabilityGridTemplateNew = JSON.parse(
          JSON.stringify(this.availabilityGridDataNew),
        );
        this.originalUserAvailabilityGridTemplateNew =
          this.convertOriginalGridDataSetNew(
            this.originalUserAvailabilityGridTemplateNew,
          );

        this.availabilityGridData =
          this.userAvailabilityGridTemplate[0].rotation;
      });
  }

  private doFloatLocationOperation(response: HomeLocation[]) {
    this.homeLocationType = response.filter(
      (x) => x.id == this.editingUser?.userDetails.homeLocationId,
    )[0].level;

    var flotLoc = { id: 0, locationName: this.useFLoatLoactionText, level: 0 };
    var nonFlotLoc = {
      id: 0,
      locationName: this.useHomeLocationText,
      level: 0,
    };
    if (this.homeLocationType == 5) {
      //if user's home location is branch
      if (this.userService?.getEditingUser()?.userDetails.isFloat) {
        this.defaultItem = flotLoc;
      } else {
        this.defaultItem = nonFlotLoc;
      }
      this.userWorkLocationList = response.filter((x) => x.level == 5);
    } else {
      if (this.userService?.getEditingUser()?.userDetails.isFloat) {
        this.defaultItem = flotLoc;
      } else {
        this.defaultItem = nonFlotLoc;
      }
      this.userWorkLocationList = response.filter((x) => x.level == 5);
    }
  }

  /**
   * Triggered when Appointment Settings, Meeting Preference selection changes
   * @param meetingPreferenceSelection
   */
  public onMeetingPreferenceSelectionChange(
    meetingPreferenceSelection: Array<IListItemModel>,
  ) {
    this.meetingPreferenceList = [];
    this.userService.setUnsaveChangesInAppointmentSettings(true);
    this.meetingPreferenceList = this.meetingPreferenceList.concat(
      meetingPreferenceSelection,
    );
    this.changeAvailabilityTempDataSetMeetingPreferenceSelections();
    this.isSaveDisabled = false;
  }

  private setMeetingPrefSelectorState(
    availabilityGridData: AvailabilityTemplate[],
    meetingPrefs: Array<IListItemModel>,
    allMPs: IAllMPs,
  ) {
    availabilityGridData.forEach((avt) => {
      avt.availabilityTempateDay.forEach((atd) => {
        atd.availabilityTimeRange.forEach((atr) => {
          const selectedMps = atr.selectedMeetingPreference;
          let meetingPrefClone: IListItemModel[] = _.cloneDeep(meetingPrefs);
          if (selectedMps.length == 1) {
            meetingPrefClone.filter(
              (mpc) => mpc.id == selectedMps[0].id,
            )[0].isDisabled = true;
          }
          allMPs[atr.userHoursOfOperationId] = meetingPrefClone;
        });
      });
    });
  }

  /**
   * Change Availability grid data set according to the Appointment Settings tab changes
   */
  public changeAvailabilityTempDataSetMeetingPreferenceSelections() {
    let inperson = this.meetingPreferenceList.some(
      (item) => item.id == MeetingPreference.InPerson,
    );
    let phone = this.meetingPreferenceList.some(
      (item) => item.id == MeetingPreference.Phone,
    );
    let virtual = this.meetingPreferenceList.some(
      (item) => item.id == MeetingPreference.Virtual,
    );

    this.availabilityGridDataNew.forEach((element) => {
      element.availabilityTempateDay.forEach((day) => {
        day.availabilityTimeRange.forEach((timerange) => {
          timerange.eligibleForInPersonAppointments = inperson;
          timerange.eligibleForPhoneAppointments = phone;
          timerange.eligibleForVirtualAppointments = virtual;
          timerange.selectedMeetingPreference = [] as Array<IListItemModel>;
          timerange.selectedMeetingPreference =
            timerange.selectedMeetingPreference.concat(
              this.meetingPreferenceList,
            );
        });
      });
    });

    this.setMeetingPrefSelectorState(
      this.availabilityGridDataNew,
      this.meetingPreferenceList,
      this.allMPs,
    );
    this.isSaveDisabled = false;
  }

  public convertOriginalGridDataSet(dataset: AvailabilityGridModel[]) {
    for (var i = 0; i < dataset.length; i++) {
      for (var j = 0; j < dataset[i].rotation.length; j++) {
        for (var k = 0; k < dataset[i].rotation[j].startTime.length; k++) {
          dataset[i].rotation[j].startTime[k] = new Date(
            dataset[i].rotation[j].startTime[k],
          );
          dataset[i].rotation[j].endTime[k] = new Date(
            dataset[i].rotation[j].endTime[k],
          );
        }
      }
    }
    return dataset;
  }

  public convertOriginalGridDataSetNew(dataset: AvailabilityTemplate[]) {
    dataset.forEach((ele) => {
      ele.availabilityTempateDay.forEach((day) => {
        day.availabilityTimeRange.forEach((timerange) => {
          timerange.startTime = new Date(timerange.startTime);
          timerange.endTime = new Date(timerange.endTime);
        });
      });
    });
    return dataset;
  }

  public setLocationSelecorValue() {
    this.userService
      .getLHomeLocations()
      .subscribe((response: HomeLocation[]) => {
        // Populate worklocation drop-down
        this.doFloatLocationOperation(response);
      });
  }

  /**
   * Get user availablity template data
   */

  public getUserAvailablityTemplateData() {
    if (this.editingUser?.userHoursOfOperations == undefined) {
      throw Error(
        "this.editingUser?.userHoursOfOperations was undefined! Which was not expected!",
      );
    }

    this.userAvailabilityTemplate.UserHoursOfOperations =
      this.editingUser?.userHoursOfOperations;
    this.adoptDataToAvailabilityTemplateGrid();
  }

  /**
   * Convert backend data set to the grid dataset
   */
  public adoptDataToAvailabilityTemplateGrid() {
    var userAvailablituMap = new Map();

    this.userAvailabilityTemplate.UserHoursOfOperations.forEach((element) => {
      if (userAvailablituMap.has(element.weekNumber)) {
        userAvailablituMap.get(element.weekNumber).push(element);
      } else {
        let UserHoursOfOperations: UserHoursOfOperations[] = [];
        UserHoursOfOperations.push(element);
        userAvailablituMap.set(element.weekNumber, UserHoursOfOperations);
      }
    });

    for (let key of userAvailablituMap.keys()) {
      let availabilitiyGridModel = new AvailabilityGridModel();
      availabilitiyGridModel.id = key;
      availabilitiyGridModel.displayValue = "Rotation " + key;
      availabilitiyGridModel.rotation = [];

      var currentDate = new Date();

      userAvailablituMap.get(key).forEach((element: any) => {
        var merged: boolean = false;
        if (availabilitiyGridModel.rotation.length > 0) {
          availabilitiyGridModel.rotation.forEach((ele) => {
            if (ele.dayOfWeek == element.dayNumber) {
              merged = true;
              var startTime = element.startTime.split(":", 3);
              ele.startTime.push(
                new Date(
                  currentDate.getFullYear(),
                  currentDate.getMonth(),
                  currentDate.getDate(),
                  startTime[0],
                  startTime[1],
                  startTime[2],
                ),
              );
              var endDate = element.endTime.split(":", 3);
              ele.endTime.push(
                new Date(
                  currentDate.getFullYear(),
                  currentDate.getMonth(),
                  currentDate.getDate(),
                  endDate[0],
                  endDate[1],
                  endDate[2],
                ),
              );
              let locationId = new LocationIdModel();
              locationId.id =
                element.workLocationId == null ? 0 : element.workLocationId;
              ele.userWorkLocation.push(locationId);
              ele.userHoursOfOperationId.push(element.userHoursOfOperationId);
            }
          });
          if (!merged) {
            let rotation = new UserRotation();
            rotation.isAvailable = element.isAvailable;
            rotation.dayOfWeek = element.dayNumber;
            rotation.userHoursOfOperationId = [];
            rotation.userHoursOfOperationId.push(
              element.userHoursOfOperationId,
            );
            rotation.startTime = [];
            var startTime = element.startTime.split(":", 3);
            rotation.startTime.push(
              new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate(),
                startTime[0],
                startTime[1],
                startTime[2],
              ),
            );
            rotation.endTime = [];
            var endDate = element.endTime.split(":", 3);
            rotation.endTime.push(
              new Date(
                currentDate.getFullYear(),
                currentDate.getMonth(),
                currentDate.getDate(),
                endDate[0],
                endDate[1],
                endDate[2],
              ),
            );
            rotation.userWorkLocation = [];
            let locationId = new LocationIdModel();
            locationId.id =
              element.workLocationId == null ? 0 : element.workLocationId;
            rotation.userWorkLocation.push(locationId);
            availabilitiyGridModel.rotation.push(rotation);
          }
        } else {
          let rotation = new UserRotation();
          rotation.isAvailable = element.isAvailable;
          rotation.dayOfWeek = element.dayNumber;
          rotation.userHoursOfOperationId = [];
          rotation.userHoursOfOperationId.push(element.userHoursOfOperationId);
          rotation.startTime = [];
          var startTime = element.startTime.split(":", 3);
          rotation.startTime.push(
            new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              startTime[0],
              startTime[1],
              startTime[2],
            ),
          );
          rotation.endTime = [];
          var endDate = element.endTime.split(":", 3);
          rotation.endTime.push(
            new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              endDate[0],
              endDate[1],
              endDate[2],
            ),
          );
          rotation.userWorkLocation = [];
          let locationId = new LocationIdModel();
          locationId.id =
            element.workLocationId == null ? 0 : element.workLocationId;
          rotation.userWorkLocation.push(locationId);
          availabilitiyGridModel.rotation.push(rotation);
        }
      });
      this.userAvailabilityGridTemplate.push(availabilitiyGridModel);
    }
  }

  /**
   * Convert grid data set to backend data set
   */
  public adoptDataToAvailabilityTemplatePostModel() {
    let userId = this.editingUserId;
    let availabilityPostModel = new AvailabilityPostModel();
    // availabilityPostModel.userId = JSON.stringify(userId);
    let weekNumberofNewRotations;
    let rotationNumber = 0;
    let CountOfuserHoursOfOperationIds: number[] = [];
    availabilityPostModel.UserHoursOfOperations = [];
    let isNewRotation = [];
    this.availabilityGridDataNew.forEach((element) => {
      rotationNumber++;
      element.availabilityTempateDay.forEach((day) => {
        day.availabilityTimeRange.forEach((timerange) => {
          if (this.availabilityGridDataNew.length > 1) {
            //making changes to the cloned rotation which needs to save as another week
            day.weekNumber = rotationNumber;
            CountOfuserHoursOfOperationIds.push(
              timerange.userHoursOfOperationId,
            );
            isNewRotation = CountOfuserHoursOfOperationIds.filter(
              (element, index, array) => array.indexOf(element) !== index,
            );
            if (rotationNumber > 1 && isNewRotation.length > 0)
              timerange.userHoursOfOperationId = 0;
          }
          let object = {
            userHoursOfOperationId:
              timerange.userHoursOfOperationId > 0
                ? timerange.userHoursOfOperationId
                : 0,
            userId: userId,
            dayNumber: day.dayOfWeek,
            weekNumber: day.weekNumber,
            startTime: moment(timerange.startTime).format("HH:mm"),
            endTime: moment(timerange.endTime).format("HH:mm"),
            workLocationId:
              timerange.userWorkLocation == 0
                ? null
                : timerange.userWorkLocation,
            isAvailable: day.isAvailable,
            eligibleForInPersonAppointments: this.appointmentsEnabled
              ? timerange.eligibleForInPersonAppointments
              : false,
            eligibleForPhoneAppointments: this.appointmentsEnabled
              ? timerange.eligibleForPhoneAppointments
              : false,
            eligibleForVirtualAppointments: this.appointmentsEnabled
              ? timerange.eligibleForVirtualAppointments
              : false,
          };
          availabilityPostModel.UserHoursOfOperations.push(object);
        });
      });
    });
    return availabilityPostModel;
  }

  /**
   * Adds an subItem to the row
   * @param dataItem
   * @param rowIndex
   * @param index
   */
  public addItem(dataItem: any, timeRange: AvailabilityTimeRange) {
    if (this.newIndex == null) {
      throw Error("this.newIndex was null! Which was not expected!");
    }
    let newAvailabilityTempTimeRange = new AvailabilityTimeRange();

    newAvailabilityTempTimeRange.startTime = new Date(timeRange.startTime);
    newAvailabilityTempTimeRange.endTime = new Date(timeRange.endTime);
    newAvailabilityTempTimeRange.userHoursOfOperationId = this.newIndex--;
    newAvailabilityTempTimeRange.userWorkLocation = timeRange.userWorkLocation;
    newAvailabilityTempTimeRange.eligibleForVirtualAppointments =
      timeRange.eligibleForVirtualAppointments;
    newAvailabilityTempTimeRange.eligibleForInPersonAppointments =
      timeRange.eligibleForInPersonAppointments;
    newAvailabilityTempTimeRange.eligibleForPhoneAppointments =
      timeRange.eligibleForPhoneAppointments;
    newAvailabilityTempTimeRange.selectedMeetingPreference =
      [] as Array<IListItemModel>;
    if (newAvailabilityTempTimeRange.eligibleForVirtualAppointments) {
      newAvailabilityTempTimeRange.selectedMeetingPreference.push({
        id: MeetingPreference.Virtual,
        displayValue: this.translateService.instant("_General_Virtual_Text_"),
        isDisabled: false,
      });
    }
    if (newAvailabilityTempTimeRange.eligibleForInPersonAppointments) {
      newAvailabilityTempTimeRange.selectedMeetingPreference.push({
        id: MeetingPreference.InPerson,
        displayValue: this.translateService.instant("_User_In_Person_Ts_Text_"),
        isDisabled: false,
      });
    }
    if (newAvailabilityTempTimeRange.eligibleForPhoneAppointments) {
      newAvailabilityTempTimeRange.selectedMeetingPreference.push({
        id: MeetingPreference.Phone,
        displayValue: this.translateService.instant("_General_Phone_Text_"),
        isDisabled: false,
      });
    }
    let indexgrid = this.allGridData.findIndex(
      (value) => value.id === this.rotate.id,
    );
    this.availabilityGridData = this.allGridData[indexgrid].rotation;
    //dataItem.availabilityTimeRange.push(newAvailabilityTempTimeRange);

    //add new time slot for the specific rotation
    let gridDataNew = _.cloneDeep(this.availabilityGridDataNew[indexgrid]);
    gridDataNew.availabilityTempateDay[
      dataItem.dayOfWeek
    ].availabilityTimeRange.push(newAvailabilityTempTimeRange);
    this.availabilityGridDataNew[indexgrid] = gridDataNew;
    this.availabilityGridDataNew.length;
    this.availabilityGridDataDisplay =
      this.availabilityGridDataNew[indexgrid].availabilityTempateDay;

    //validate the newly added timeslot with other time slots
    this.validateTime(
      gridDataNew.availabilityTempateDay[dataItem.dayOfWeek]
        .availabilityTimeRange,
      newAvailabilityTempTimeRange,
    );
  }

  /**
   * deletes an subItem from the row
   * @param dataItem
   * @param rowIndex
   * @param i
   */
  public deleteItem(dataItems: any, rowIndex: number, i: number) {
    this.availabilityGridDataNew[this.rotate.id - 1].availabilityTempateDay[
      rowIndex
    ].availabilityTimeRange.splice(i, 1);
    this.validateOverlappingTimeRanges(dataItems);
    this.isSaveDisabled = false;
    this.validate();
    this.availabilityGridDataDisplay =
      this.availabilityGridDataNew[this.rotate.id - 1].availabilityTempateDay;
  }

  /**
   * Triggers when rotation changes
   */
  public rotationChange() {
    let index = this.allGridData.findIndex(
      (value) => value.id === this.rotate.id,
    );
    //this.availabilityGridData = this.allGridData[index].rotation;
    this.availabilityGridDataDisplay =
      this.availabilityGridDataNew[index].availabilityTempateDay;
    this.availabilityGridData = this.availabilityGridDataNew[index];
  }

  /**
   * Pre calculate dropdown values to the popup
   * @param event
   */
  public onToggleMove(event?: any): void {
    this.calcluateDropDownValuesToMove();
  }

  /**
   * Triggers when user clicks no in the Move Popup
   * @param event
   */
  public onToggleMoveNo(event?: any): void {
    this.show2 = false;
  }

  /**
   * Calculates the drop down values of the Move popup
   */
  public calcluateDropDownValuesToMove() {
    let changeRotationList = new Array<any>();
    let clonedArray: IListItemModel[] = JSON.parse(
      JSON.stringify(this.rotationList),
    );
    if (this.rotationList.length > 0) {
      if (this.rotationList.length <= 2) {
        let selectedIndex = clonedArray.findIndex((value) => {
          return value.id == this.rotate.id;
        });
        if (selectedIndex == 0) {
          this.show2 = false;
        } else {
          this.show2 = true;
          clonedArray.splice(selectedIndex, 1);
          this.moveList = clonedArray;
        }
      } else {
        let selectedIndex = clonedArray.findIndex((value) => {
          return value.id == this.rotate.id;
        });
        clonedArray.splice(selectedIndex, 2);
        this.moveList = clonedArray;
        this.show2 = true;
      }
    }
  }

  /**
   * Triggers when move popup yes clicked
   * @param before
   * @param selected
   */
  public onMove(before: any, selected: any) {
    let selectedIndex = this.allGridData.findIndex((value) => {
      return value.id == selected.id;
    });
    let beforeIndex = this.allGridData.findIndex((value) => {
      return value.id == before.id;
    });

    if (before.id < selected.id) {
      this.gridTemplateMove(
        this.availabilityGridDataNew,
        beforeIndex,
        selectedIndex - 1,
      );
    } else {
      this.gridTemplateMove(
        this.availabilityGridDataNew,
        beforeIndex,
        selectedIndex,
      );
    }

    this.rotate = this.rotationList[0];
    this.availabilityGridDataDisplay =
      this.availabilityGridDataNew[0].availabilityTempateDay;
    this.show2 = false;
    this.isSaveDisabled = false;
  }

  public gridTemplateMove(gridList: any, old_index: number, new_index: number) {
    //keeping gridList as any type because gridList length need to be adjusted by pushing undefined elements
    while (old_index < 0) {
      old_index += gridList.length;
    }
    while (new_index < 0) {
      new_index += gridList.length;
    }
    if (new_index >= gridList.length) {
      var k = new_index - gridList.length + 1;
      while (k--) {
        gridList.push(undefined);
      }
    }
    gridList.splice(new_index, 0, gridList.splice(old_index, 1)[0]);
    return gridList;
  }

  private deepCloneAvailabilityTemplateWithNewIds(
    source: AvailabilityTemplate,
  ): AvailabilityTemplate {
    const clone = _.cloneDeep(source);
    clone.availabilityTempateDay.forEach((day) => {
      day.availabilityTimeRange.forEach((tr) => {
        // assign a new temporary negative id; will be saved as 0 in POST
        tr.userHoursOfOperationId = this.newIndex!--;
        // ensure Date instances
        tr.startTime = new Date(tr.startTime);
        tr.endTime = new Date(tr.endTime);
        // clone meeting preferences to avoid shared references
        tr.selectedMeetingPreference = _.cloneDeep(
          tr.selectedMeetingPreference || [],
        );
        // reset validation flags
        tr.isStartTimeOverlapped = false;
        tr.isEndTimeOverlapped = false;
        tr.isStartTimeValid = true;
        tr.isEndTimeValid = true;
      });
    });
    return clone;
  }
  /**
   * Triggers on user clicked Add
   */
  public onYesClicked() {
    if (this.selectedRotation) {
      let index = this.allGridData.findIndex(
        (value) => value.id === this.selectedRotation?.id,
      );

      let clonedRotation = _.cloneDeep(this.allGridData[index]);
      clonedRotation.id = this.userAvailabilityGridTemplate.length + 1;
      clonedRotation.displayValue = `Rotation ${this.userAvailabilityGridTemplate.length + 1}`;

      clonedRotation.rotation.forEach((element) => {
        element.userHoursOfOperationId = element.userHoursOfOperationId.map(
          () => 0,
        );
      });

      this.allGridData.push(clonedRotation);
      this.originalUserAvailabilityGridTemplate.push(
        _.cloneDeep(clonedRotation),
      );
      this.availabilityGridData = clonedRotation.rotation;

      //make a copy of already created grid template and assign it as a new rotation
      var copyOfGrid = this.availabilityGridDataNew[index];
      const newTemplate =
        this.deepCloneAvailabilityTemplateWithNewIds(copyOfGrid);
      this.availabilityGridDataNew.push(newTemplate);
      this.availabilityGridDataNew.length;

      this.setMeetingPrefSelectorState(
        this.availabilityGridDataNew,
        this.meetingPreferenceList,
        this.allMPs,
      );

      this.rotationList = this.allGridData.map(({ id, displayValue }) => ({
        id,
        displayValue,
      }));
      this.rotate = {
        id: clonedRotation.id,
        displayValue: clonedRotation.displayValue,
      };
      this.onToggle();
      this.isSaveDisabled = false;

      this.availabilityGridDataDisplay =
        this.availabilityGridDataNew[
          this.userAvailabilityGridTemplate.length - 1
        ].availabilityTempateDay;
    }
  }

  public onRemoveClicked() {
    if (this.availabilityGridDataNew.length > 1) {
      let index = this.allGridData.findIndex(
        (value) => value.id === this.rotate.id,
      );
      let idOfdelte =
        this.availabilityGridDataNew[index].availabilityTempateDay[0]
          .availabilityTimeRange[0].userHoursOfOperationId;

      //remove rotation from DB table
      this.userService.removeAvailabilityTemplate(idOfdelte).subscribe(
        (data) => {
          this.toastService.showSuccess("_User_Delete_Success_Ts_Text_");
          this.rotationList.length;
          this.availabilityGridDataNew.length;

          //get the editing user details to update the availability grid

          this.refreshGridTemplate();

          //this.rotationList = this.allGridData.map(({ id, displayValue }) => ({ id, displayValue }));
        },
        (error) => {
          console.log(error);
          this.toastService.showError("_User_Deleting_Failed_Ts_Text_");
        },
      );
      this.rotationList.length;
      this.availabilityGridDataNew.length;
      this.availabilityGridDataDisplay =
        this.availabilityGridDataNew[0].availabilityTempateDay;
      this.onToggleRemove();
    }
  }

  /**
   *
   * Covert day to string
   */
  public transformDay(value: number) {
    switch (value) {
      case 0: {
        return "_User_Sunday_Ts_Text_";
      }
      case 1: {
        return "_User_Monday_Ts_Text_";
      }
      case 2: {
        return "_User_Tuesday_Ts_Text_";
      }
      case 3: {
        return "_User_Wednesday_Ts_Text_";
      }
      case 4: {
        return "_User_Thursday_Ts_Text_";
      }
      case 5: {
        return "_User_Friday_Ts_Text_";
      }
      case 6: {
        return "_User_Saturday_Ts_Text_";
      }
      default: {
        throw new Error("Unexpected Code path reached! Invalid day.");
      }
    }
  }

  /**
   * Transform Data according POST ModeL
   * @param va
   */
  public transformAvailabililtyDataToPost(va: any) {
    let availabilityPostModel = new AvailabilityPostModel();
    // availabilityPostModel.userId = JSON.stringify(0);
    availabilityPostModel.UserHoursOfOperations = [];
    va.forEach((element: any) => {
      element.rotation.forEach((ele: any) => {
        let newArray = ele.startTime.map(function (value: any, index: number) {
          let object = {
            userHoursOfOperationId: 0,
            userId: 0,
            dayNumber: ele.dayOfWeek,
            weekNumber: element.id,
            startTime: moment(value).format("HH:mm"),
            endTime: moment(ele.endTime[index]).format("HH:mm"),
            workLocationId: ele.userWorkLocation[index],
            isAvailable: ele.isAvailable,
            eligibleForInPersonAppointments:
              ele.eligibleForInPersonAppointments,
            eligibleForPhoneAppointments: ele.eligibleForPhoneAppointments,
            eligibleForVirtualAppointments: ele.eligibleForVirtualAppointments,
          };
          availabilityPostModel.UserHoursOfOperations.push(object);
        });
      });
    });
  }

  public onNoClicked() {
    this.selectedRotation = null;
    this.onToggle();
  }

  public refreshGridTemplate() {
    this.userService.getEditingUserDetails(this.editingUserId).subscribe(
      (userData) => {
        if (this.editingUser != null) {
          this.editingUser.userHoursOfOperations =
            userData.userHoursOfOperations;
          this.clearExistingData();
          this.loadAvailabilityTemplateData();
        } else {
          throw Error("this.editingUser was null! Which was not expected!");
        }
      },
      (error) => {
        console.log(error);
        this.toastService.showError("_User_Reloading_Failed_Ts_Text_");
      },
    );
  }

  public onNoRemoveClicked() {
    this.selectedRotation = null;
    this.onToggleRemove();
  }

  public checkAllGridDataLength() {
    if (this.allGridData?.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  public onToggle(event?: any): void {
    this.show = !this.show;
    this.selectedRotation = this.rotate;
  }

  public onToggleRemove(event?: any): void {
    this.showRemove = !this.showRemove;
    this.selectedRotation = this.rotate;
  }
  public onToggleOccurs(event?: any): void {
    switch (event) {
      case "OPEN":
        this.initRotation();
        break;
      case "CLOSE":
        this.show1 = false;
        break;
    }
  }

  public checkedChanged(event: any) {
    let _isAvailable: boolean;
    _isAvailable = false;

    if (this.rotationList.length == 0) {
      event.isAvailable = !event.isAvailable;
      let availabilityTempTimeRangeList: AvailabilityTimeRange[] = [];
      let availabilityTempTimeRange = new AvailabilityTimeRange();
      availabilityTempTimeRange.startTime = JSON.parse(
        JSON.stringify(
          this.originalUserAvailabilityGridTemplateNew[this.rotate.id - 1]
            .availabilityTempateDay[event.dayOfWeek].availabilityTimeRange[0]
            .startTime,
        ),
      );
      availabilityTempTimeRange.endTime = JSON.parse(
        JSON.stringify(
          this.originalUserAvailabilityGridTemplateNew[this.rotate.id - 1]
            .availabilityTempateDay[event.dayOfWeek].availabilityTimeRange[0]
            .endTime,
        ),
      );
      availabilityTempTimeRange.userHoursOfOperationId = JSON.parse(
        JSON.stringify(
          this.originalUserAvailabilityGridTemplateNew[this.rotate.id - 1]
            .availabilityTempateDay[event.dayOfWeek].availabilityTimeRange[0]
            .userHoursOfOperationId,
        ),
      );
      availabilityTempTimeRange.userWorkLocation = JSON.parse(
        JSON.stringify(
          this.originalUserAvailabilityGridTemplateNew[this.rotate.id - 1]
            .availabilityTempateDay[event.dayOfWeek].availabilityTimeRange[0]
            .userWorkLocation,
        ),
      );

      // Remove this after QA verification
      // availabilityTempTimeRange.eligibleForVirtualAppointments = JSON.parse(JSON.stringify(this.originalUserAvailabilityGridTemplateNew[this.rotate.id -1].availabilityTempateDay[event.dayOfWeek].availabilityTimeRange[0].eligibleForVirtualAppointments));
      // availabilityTempTimeRange.eligibleForInPersonAppointments = JSON.parse(JSON.stringify(this.originalUserAvailabilityGridTemplateNew[this.rotate.id -1].availabilityTempateDay[event.dayOfWeek].availabilityTimeRange[0].eligibleForInPersonAppointments));
      // availabilityTempTimeRange.eligibleForPhoneAppointments = JSON.parse(JSON.stringify(this.originalUserAvailabilityGridTemplateNew[this.rotate.id -1].availabilityTempateDay[event.dayOfWeek].availabilityTimeRange[0].eligibleForPhoneAppointments));

      availabilityTempTimeRange.eligibleForInPersonAppointments =
        this.meetingPreferenceList.some(
          (item) => item.id == MeetingPreference.InPerson,
        );
      availabilityTempTimeRange.eligibleForPhoneAppointments =
        this.meetingPreferenceList.some(
          (item) => item.id == MeetingPreference.Phone,
        );
      availabilityTempTimeRange.eligibleForVirtualAppointments =
        this.meetingPreferenceList.some(
          (item) => item.id == MeetingPreference.Virtual,
        );

      availabilityTempTimeRange.selectedMeetingPreference =
        [] as Array<IListItemModel>;
      if (availabilityTempTimeRange.eligibleForInPersonAppointments) {
        availabilityTempTimeRange.selectedMeetingPreference.push({
          id: MeetingPreference.InPerson,
          displayValue: this.translateService.instant(
            "_User_In_Person_Ts_Text_",
          ),
          isDisabled: false,
        });
      }
      if (availabilityTempTimeRange.eligibleForPhoneAppointments) {
        availabilityTempTimeRange.selectedMeetingPreference.push({
          id: MeetingPreference.Phone,
          displayValue: this.translateService.instant("_General_Phone_Text_"),
          isDisabled: false,
        });
      }
      if (availabilityTempTimeRange.eligibleForVirtualAppointments) {
        availabilityTempTimeRange.selectedMeetingPreference.push({
          id: MeetingPreference.Virtual,
          displayValue: this.translateService.instant("_General_Virtual_Text_"),
          isDisabled: false,
        });
      }
      availabilityTempTimeRangeList.push(availabilityTempTimeRange);
      this.availabilityGridDataNew[this.rotate.id - 1].availabilityTempateDay[
        event.dayOfWeek
      ].availabilityTimeRange = availabilityTempTimeRangeList;
      this.availabilityGridDataNew = this.convertOriginalGridDataSetNew(
        this.availabilityGridDataNew,
      );
    } else {
      //using this at the moment
      let gridDataNew = _.cloneDeep(
        this.availabilityGridDataNew[this.rotate.id - 1],
      );
      _isAvailable = !event.isAvailable;
      gridDataNew.availabilityTempateDay[event.dayOfWeek].isAvailable =
        _isAvailable;

      this.availabilityGridDataNew[this.rotate.id - 1] = gridDataNew;
      this.availabilityGridDataDisplay =
        this.availabilityGridDataNew[this.rotate.id - 1].availabilityTempateDay;
    }

    this.isSaveDisabled = false;
    if (this.appointmentsEnabled) {
      this.checkForInvalidMeetingPreference();
    }

    this.validate();
  }

  // Commented and kept just for one release
  // onStartTimeChangeOld(event, value, index) {
  //   event.startTime[index] = value;
  // }

  // onEndTimeChangeOld(event, value, index) {
  //   event.endTime[index] = value;
  // }

  // public onWorkLocationChangeOld(event, value, index) {
  //   event.userWorkLocation[index].id = value.id;
  // }

  onStartTimeChange(event: any, value: any, index: number) {
    let gridDataNew = this.timeSlotsChangeOfRotations(event, index, true);
    this.validateTime(
      gridDataNew.availabilityTempateDay[event.dayOfWeek].availabilityTimeRange,
      gridDataNew.availabilityTempateDay[event.dayOfWeek].availabilityTimeRange[
        index
      ],
      value,
    );
    //event.availabilityTimeRange[index].isPreviousInputStartTime = true;
  }

  onEndTimeChange(event: any, value: any, index: number) {
    let gridDataNew = this.timeSlotsChangeOfRotations(event, index, false);
    this.validateTime(
      gridDataNew.availabilityTempateDay[event.dayOfWeek].availabilityTimeRange,
      gridDataNew.availabilityTempateDay[event.dayOfWeek].availabilityTimeRange[
        index
      ],
      value,
      false,
    );
  }

  public timeSlotsChangeOfRotations(
    event: any,
    index: number,
    isPreviousInputStartTime: any,
  ) {
    //when srat time or end time change in any rotaion, that apply for only that rotaion
    let indexOfRot = this.allGridData.findIndex(
      (value) => value.id === this.rotate.id,
    );

    let gridDataNew = _.cloneDeep(this.availabilityGridDataNew[indexOfRot]);
    gridDataNew.availabilityTempateDay[event.dayOfWeek].availabilityTimeRange[
      index
    ].isPreviousInputStartTime = isPreviousInputStartTime;
    this.availabilityGridDataNew[indexOfRot] = gridDataNew;
    this.availabilityGridDataDisplay =
      this.availabilityGridDataNew[indexOfRot].availabilityTempateDay;

    return gridDataNew;
  }

  public onWorkLocationChange(event: any, value: any, index: number) {
    event.availabilityTimeRange[index].userWorkLocation = value;
    this.isSaveDisabled = false;
  }

  public onSelectMeetingPreference(
    event: any,
    dataitem: any,
    userHrsId: number,
  ) {
    if (dataitem.selectedMeetingPreference.length > 1) {
      const mpClone = _.cloneDeep(this.allMPs);
      mpClone[userHrsId].map((mp: any) => (mp.isDisabled = false));
      this.allMPs = mpClone;
    }

    switch (event.id) {
      case MeetingPreference.Virtual:
        dataitem.eligibleForVirtualAppointments = true;
        break;
      case MeetingPreference.InPerson:
        dataitem.eligibleForInPersonAppointments = true;
        break;
      case MeetingPreference.Phone:
        dataitem.eligibleForPhoneAppointments = true;
        break;
      default:
        break;
    }
    this.propagateMeetingPreferenceToDay(
      userHrsId,
      dataitem.selectedMeetingPreference,
    );

    this.checkForInvalidMeetingPreference();
    this.isSaveDisabled = false;
  }

  public onDeSelectMeetingPreference(
    event: any,
    dataitem: any,
    userHrsId: number,
  ) {
    if (dataitem.selectedMeetingPreference.length == 1) {
      const mpClone = _.cloneDeep(this.allMPs);
      mpClone[userHrsId].filter(
        (mp: any) => mp.id == dataitem.selectedMeetingPreference[0].id,
      )[0].isDisabled = true;
      this.allMPs = mpClone;
    }

    switch (event.id) {
      case MeetingPreference.Virtual:
        dataitem.eligibleForVirtualAppointments = false;
        break;
      case MeetingPreference.InPerson:
        dataitem.eligibleForInPersonAppointments = false;
        break;
      case MeetingPreference.Phone:
        dataitem.eligibleForPhoneAppointments = false;
        break;
      default:
        break;
    }
    this.propagateMeetingPreferenceToDay(
      userHrsId,
      dataitem.selectedMeetingPreference,
    );

    this.checkForInvalidMeetingPreference();
    this.isSaveDisabled = false;
  }

  private propagateMeetingPreferenceToDay(
    referenceUserHoursId: number,
    selectedMps: IListItemModel[],
  ) {
    const rotIdx = this.allGridData.findIndex((v) => v.id === this.rotate.id);
    if (rotIdx < 0) {
      return;
    }

    const rotation = this.availabilityGridDataNew[rotIdx];
    const day = rotation.availabilityTempateDay.find((d) =>
      d.availabilityTimeRange.some(
        (tr) => tr.userHoursOfOperationId === referenceUserHoursId,
      ),
    );
    if (!day) {
      return;
    }

    const hasInPerson = selectedMps.some(
      (mp) => mp.id === MeetingPreference.InPerson,
    );
    const hasPhone = selectedMps.some(
      (mp) => mp.id === MeetingPreference.Phone,
    );
    const hasVirtual = selectedMps.some(
      (mp) => mp.id === MeetingPreference.Virtual,
    );

    day.availabilityTimeRange.forEach((tr) => {
      tr.selectedMeetingPreference = _.cloneDeep(selectedMps);
      tr.eligibleForInPersonAppointments = hasInPerson;
      tr.eligibleForPhoneAppointments = hasPhone;
      tr.eligibleForVirtualAppointments = hasVirtual;

      // Refresh per-timeslot dropdown option state (disabled if only one selected)
      let mpClone: IListItemModel[] = _.cloneDeep(this.meetingPreferenceList);
      if (selectedMps.length === 1) {
        const selId = selectedMps[0].id;
        const item = mpClone.find((mpc) => mpc.id === selId);
        if (item) {
          item.isDisabled = true;
        }
      } else {
        mpClone.forEach((mpc) => (mpc.isDisabled = false));
      }
      this.allMPs[tr.userHoursOfOperationId] = mpClone;
    });

    this.availabilityGridDataDisplay = rotation.availabilityTempateDay;
  }

  /**
   * Check whether at least one of the meeting preference option is selected from the Meeting Preference drop down
   */
  public checkForInvalidMeetingPreference() {
    this.invalidMeetingPreference = false;
    this.availabilityGridDataNew.forEach((element) => {
      element.availabilityTempateDay.forEach((day) => {
        day.availabilityTimeRange.forEach((timerange) => {
          if (
            day.isAvailable &&
            timerange.selectedMeetingPreference.length == 0
          ) {
            this.invalidMeetingPreference = true;
          }
        });
      });
    });
  }

  public isMeeting(date: any) {
    let match = this.rotationSelectedDates.find(
      (rsd) => rsd.getTime() == date.getTime(),
    );
    return match ? "meeting" : "";
  }

  public okClicked() {}

  public cancelClicked() {
    this.availabilityGridDataDisplay =
      this.availabilityGridDataNew[0].availabilityTempateDay;
    this.refreshGridTemplate();
    this.closeEmitter.emit("ngb-panel-1");
    this.isSaveDisabled = true;
  }

  /**
   * Save availability template data
   */
  public saveClicked() {
    if (this.verifyUnsaveChangesInAppointment()) {
      let availabilityPostModel =
        this.adoptDataToAvailabilityTemplatePostModel();

      this.userService
        .saveAvailabilityTemplate(availabilityPostModel)
        .subscribe(
          (data) => {
            this.userService
              .getEditingUserDetails(this.editingUserId)
              .subscribe(
                (userData) => {
                  if (this.editingUser != null) {
                    this.userService.setEditingUser(userData);
                    this.toastService.showSuccess(
                      "_General_Changes_Saved_Successfully_Ts_Text_",
                    );
                    this.isSaveDisabled = true;
                    this.dirtyEmitter.emit(false);
                    this.editingUser.userHoursOfOperations =
                      userData.userHoursOfOperations;
                    this.clearExistingData();
                    this.loadAvailabilityTemplateData();
                  } else {
                    throw Error(
                      "this.editingUser was undefined! Which was not expected!",
                    );
                  }
                },
                (error) => {
                  console.log(error);
                  this.toastService.showError(
                    "_General_Saving_Failed_Ts_Text_",
                  );
                },
              );
          },
          (error) => {
            console.log(error);
            this.toastService.showError("_General_Saving_Failed_Ts_Text_");
          },
        );
    }
  }

  private timeRangeValidate() {
    this.isAvailabilityTimeRangesValid = true;
    this.availabilityGridDataNew.forEach((ele) => {
      ele.availabilityTempateDay.forEach((day) => {
        day.availabilityTimeRange.forEach((timerange) => {
          let isValid: boolean =
            timerange.startTime >= timerange.endTime ? false : true;
          if (timerange.isPreviousInputStartTime) {
            timerange.isStartTimeValid = isValid;
            timerange.isEndTimeValid = true;
          } else {
            timerange.isEndTimeValid = isValid;
            timerange.isStartTimeValid = true;
          }
          if (!isValid) {
            this.isAvailabilityTimeRangesValid = false;
          }
        });
      });
    });
  }

  /**
   * Reassign selected meeting preference with different meeting preference option
   */
  public reassignMeetingPreference(
    reassigning: IListItemModel,
    reassignBy: IListItemModel,
  ) {
    this.meetingPreferenceList = this.meetingPreferenceList.filter(
      (lm) => lm.id != reassigning.id,
    );

    let inperson = this.meetingPreferenceList.some(
      (item) => item.id == MeetingPreference.InPerson,
    );
    let phone = this.meetingPreferenceList.some(
      (item) => item.id == MeetingPreference.Phone,
    );
    let virtual = this.meetingPreferenceList.some(
      (item) => item.id == MeetingPreference.Virtual,
    );

    this.availabilityGridDataNew.forEach((mp) => {
      mp.availabilityTempateDay.forEach((day) => {
        day.availabilityTimeRange.forEach((tr) => {
          if (
            tr.selectedMeetingPreference.some((mp) => mp.id == reassigning.id)
          ) {
            // Remove unchecked meeting preference option
            tr.selectedMeetingPreference = tr.selectedMeetingPreference.filter(
              (smp) => smp.id != reassigning.id,
            );
            if (
              !tr.selectedMeetingPreference.some((mp) => mp.id == reassignBy.id)
            ) {
              // Update with selected meeting preference option if already not selected
              tr.selectedMeetingPreference.push(reassignBy);
            }
          }
          tr.eligibleForInPersonAppointments = inperson;
          tr.eligibleForPhoneAppointments = phone;
          tr.eligibleForVirtualAppointments = virtual;
        });
      });
    });

    this.setMeetingPrefSelectorState(
      this.availabilityGridDataNew,
      this.meetingPreferenceList,
      this.allMPs,
    );
  }

  private sortUserOperationalHours(userAvailability: any) {
    userAvailability.userHoursOfOperations.sort(function (a: any, b: any) {
      return (
        a.weekNumber - b.weekNumber ||
        a.dayNumber - b.dayNumber ||
        new Date("1900-01-01 " + a.startTime).getTime() -
          new Date("1900-01-01 " + b.startTime).getTime()
      );
    });
  }

  get rotationId() {
    return this.rotate.id;
  }

  private initRotation() {
    this.rotationSelectedDates = [];

    let numOfRotations: number = this.rotationList.length;
    let userPreferredTimeZone = this.userService.getUserPreferedTimeZone();

    this.userService
      .getUserAvailabilityRotationByDateRange(
        numOfRotations,
        this.rotationId,
        userPreferredTimeZone?.timeZoneId,
      )
      .subscribe((response: UserAvailabilityRotationModel) => {
        this.rotationStartDate = new Date(response.startDate);
        this.rotationEndDate = new Date(response.endDate);
        response.availabilityDates.forEach((ad) => {
          this.rotationSelectedDates.push(new Date(ad));
        });
        this.show1 = !this.show1;
      });
  }

  // Time range validations
  public validateTime(
    availabilityTimeRanges: AvailabilityTimeRange[],
    availabilityTimeRange: AvailabilityTimeRange,
    event: Date | undefined = undefined,
    isStartTime: boolean = true,
  ) {
    if (event) {
      event = this.vaidateTimeSteps(event);
      if (isStartTime) {
        availabilityTimeRange.startTime = event;
      } else {
        availabilityTimeRange.endTime = event;
      }
    }

    availabilityTimeRange.isStartTimeOverlapped = false;
    availabilityTimeRange.isEndTimeOverlapped = false;
    availabilityTimeRange.isStartTimeValid = true;
    availabilityTimeRange.isEndTimeValid = true;

    this.validateOverlappingTimeRanges(availabilityTimeRanges);

    this.validateTimeRange(availabilityTimeRange, isStartTime);

    this.validate();
  }

  public validateOverlappingTimeRanges(
    availabilityTimeRanges: AvailabilityTimeRange[],
  ) {
    availabilityTimeRanges.forEach((availabilityTimeRange) => {
      let overlappingTimeRanges = availabilityTimeRanges.filter(
        (atr) =>
          !(
            (availabilityTimeRange.startTime < atr.startTime &&
              availabilityTimeRange.endTime <= atr.startTime) ||
            (availabilityTimeRange.startTime >= atr.endTime &&
              availabilityTimeRange.endTime > atr.endTime) ||
            (atr.startTime < availabilityTimeRange.startTime &&
              atr.endTime <= availabilityTimeRange.startTime) ||
            (atr.startTime >= availabilityTimeRange.endTime &&
              atr.endTime > availabilityTimeRange.endTime)
          ) &&
          atr.userHoursOfOperationId !=
            availabilityTimeRange.userHoursOfOperationId,
      );

      availabilityTimeRange.isStartTimeOverlapped = false;
      availabilityTimeRange.isEndTimeOverlapped = false;

      if (overlappingTimeRanges?.length > 0) {
        // Time slot inside Time slot
        if (
          overlappingTimeRanges.filter(
            (oltr) =>
              (oltr.startTime <= availabilityTimeRange.startTime &&
                oltr.endTime >= availabilityTimeRange.endTime) ||
              (oltr.startTime >= availabilityTimeRange.startTime &&
                oltr.endTime <= availabilityTimeRange.endTime),
          ).length > 0
        ) {
          availabilityTimeRange.isStartTimeOverlapped = true;
          availabilityTimeRange.isEndTimeOverlapped = true;
        }
        // Time slot not inside Time slot
        if (
          overlappingTimeRanges.filter(
            (oltr) =>
              availabilityTimeRange.startTime <= oltr.startTime &&
              oltr.startTime < availabilityTimeRange.endTime &&
              availabilityTimeRange.endTime < oltr.endTime,
          ).length > 0
        ) {
          availabilityTimeRange.isEndTimeOverlapped = true;
        }
        if (
          overlappingTimeRanges.filter(
            (oltr) =>
              availabilityTimeRange.startTime < oltr.endTime &&
              oltr.endTime <= availabilityTimeRange.endTime &&
              oltr.startTime < availabilityTimeRange.startTime,
          ).length > 0
        ) {
          availabilityTimeRange.isStartTimeOverlapped = true;
        }
      }
    });
  }

  public validateTimeRange(
    availabilityTimeRange: AvailabilityTimeRange,
    isStartTime: boolean = true,
  ) {
    if (
      isStartTime &&
      availabilityTimeRange.endTime <= availabilityTimeRange.startTime
    ) {
      availabilityTimeRange.isStartTimeValid = false;
    } else if (
      !isStartTime &&
      availabilityTimeRange.endTime <= availabilityTimeRange.startTime
    ) {
      availabilityTimeRange.isEndTimeValid = false;
    }
  }

  public validate() {
    this.isSaveDisabled = false;
    this.isAvailabilityTimeRangesValid = true;
    this.availabilityGridDataNew.forEach((ele) => {
      ele.availabilityTempateDay.forEach((day) => {
        day.availabilityTimeRange.forEach((timerange) => {
          if (
            timerange.isStartTimeOverlapped ||
            timerange.isEndTimeOverlapped ||
            !timerange.isStartTimeValid ||
            !timerange.isEndTimeValid
          ) {
            this.isSaveDisabled = true;
            this.isAvailabilityTimeRangesValid = false;
          }
        });
      });
    });
  }

  private vaidateTimeSteps(time: Date): Date {
    let minutes: number = time.getMinutes();
    if (minutes % this.steps.minute > 0) {
      time.setMinutes(
        minutes - (minutes % this.steps.minute) + this.steps.minute,
      );
    }
    return time;
  }
  // End - Time range validations

  public isEdited(dataItem: any): boolean {
    return true;
  }

  public clearExistingData() {
    this.rotationList.length = 0;
    this.availabilityGridDataNew.length = 0;
    this.availabilityGridDataNew.length = 0;
    this.userAvailabilityGridTemplate.length = 0;
    this.originalUserAvailabilityGridTemplate.length = 0;
    this.originalUserAvailabilityGridTemplateNew.length = 0;
  }

  public onCloseUnsaveChangesInAppointmentPopup() {
    this.showUnsaveChangesInAppointmentPopup = false;
  }

  public verifyUnsaveChangesInAppointment() {
    if (this.userService.checkUnsaveChangesInAppointmentSettings()) {
      this.showUnsaveChangesInAppointmentPopup = true;
      return false;
    }
    return true;
  }
  mouseEnter() {
    if (!this.isSaveDisabled)
      this.disableButonsToolTip =
        "Save changes before attempting further modifications";
  }
}

type location = {
  id: number;
  locationName: string;
  level: number;
};
